import React from "react";
import { Button } from "react-bootstrap";

const SurveyButton = ({ className = "", icon, solid = false, children, ...props }) => (
  <Button
    {...props}
    className={`survey-engine-action-button ${solid ? "survey-engine-action-button-solid" : ""} ${className}`.trim()}
  >
    {icon && (
      <i
        className={`fa ${icon} survey-engine-button-icon`}
        aria-hidden="true"
      />
    )}
    <span className="survey-engine-button-label">{children}</span>
  </Button>
);

export default SurveyButton;
